import {
  faCalendarDay,
  faChevronDown,
} from "@fortawesome/duotone-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, Typography } from "@joonapp/web-shared"
import dayjs, { Dayjs } from "dayjs"
import { useRef } from "react"

const DateInput = ({
  date,
  setDate,
  maxDate = dayjs().add(14, "day"),
  minDate = dayjs(),
}: {
  date: Dayjs | null
  setDate: (date: Dayjs | null) => void
  maxDate?: Dayjs | null
  minDate?: Dayjs | null
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null)

  const handleButtonClick = () => {
    if (inputRef.current) {
      inputRef.current.showPicker()
    }
  }

  return (
    <div className="relative">
      <input
        type="date"
        ref={inputRef}
        className="opacity-0 z-0 absolute top-0 left-0 h-0 w-0"
        value={date ? dayjs(date).format("YYYY-MM-DD") : ""}
        onChange={(e) => setDate(dayjs(e.target.value))}
        min={minDate?.format("YYYY-MM-DD")}
        max={maxDate?.format("YYYY-MM-DD")}
      />
      <button
        onClick={handleButtonClick}
        className="border border-borderPrimary rounded-md px-3 h-[44px] flex flex-row gap-2 items-center focus:outline-2 focus:outline-indigo-200 z-10"
      >
        <div className="border border-borderPrimary rounded-md px-3 h-[44px] flex flex-row gap-2 items-center focus:outline-2 focus:outline-indigo-200">
          <FontAwesomeIcon
            icon={faCalendarDay}
            color={JoonUIColor.icon.neutral}
          />
          <Typography variant="body">
            {dayjs(date).format("dddd, MMM D")}
          </Typography>
          <FontAwesomeIcon icon={faChevronDown} />
        </div>
      </button>
    </div>
  )
}

export default DateInput
